var _defs, _circle, _path, _path2, _path3, _circle2, _circle3, _path4, _path5, _path6, _circle4, _circle5, _path7, _path8, _path9, _path10, _line, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarSvgrepoCom2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#f2a196;}.cls-4{fill:#e88870;}.cls-5{fill:#00214e;}.cls-6,.cls-8{fill:none;stroke-miterlimit:10;}.cls-6{stroke:#ffffff;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{stroke:#00214e;}.cls-9{fill:#845161;}.cls-10{fill:#ffffff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 142.7,
    y1: 64.13,
    x2: 204.05,
    y2: 64.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 110.02,
    y1: 244.18,
    x2: 233.57,
    y2: 117.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 119.33,
    y1: 162.85,
    x2: 169.56,
    y2: 104.52,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 173.37,
    cy: 64.13,
    r: 30.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.87,230.57a324.47,324.47,0,0,1-47.8-4.38c-31.48-5.26-62.3-15.31-90.26-30.8-1.66-.93-3.32-1.87-5-2.83,24.79-23.53,43.19-52,58.74-82.2,11.2-21.79,17-36.16,41.19-45.33,42.06-15.93,98.88-.44,110.84,46.88,5.05,20,5.24,40.91,2.37,61.26-2.77,19.68-10.06,57.58-10.06,57.58S207.72,230.71,199.87,230.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.5,294.57a184.56,184.56,0,0,1-226.48-1l48.66-22.81a47.68,47.68,0,0,0,4.35-2.34l1.12-.7c.4-.25.79-.51,1.18-.78A46.54,46.54,0,0,0,153,250.46c4-7.55,5.32-15.89,5.38-24.39,0-4.67-.19-9.34-.31-14q0-1.58-.06-3.15-.06-4.76-.1-9.51l.07,0,1.91,1,5.2,2.69,30.29,5.15,31.12,5.3.71,24,.2,6.88,0,1.07.47,15.87,11.47,4.67,9,3.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.21,237.57a12.12,12.12,0,0,1-7.34,2.11c-14.79-1.59-43.64-13.18-61.8-34.63q0-1.58-.06-3.15l0-2.47,1.91,1,5.2,2.69,30.29,5.15,31.12,5.3Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 132.9,
    cy: 167.39,
    r: 17
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.9,
    cy: 165.39,
    r: 17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.44,141.65c11.75,40.68-13.2,89.87-28.54,89.87-21,0-72-16.78-83.73-57.46S140,93.14,171,84.19,236.7,101,248.44,141.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.28,150.1c6.1.05,6.1,9.37,0,9.42H185c-6.1-.05-6.1-9.37,0-9.42h.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M235.54,146.26c5.67.05,5.67,8.7,0,8.75h-.25c-5.66,0-5.66-8.7,0-8.75h.25Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 185.27,
    cy: 154.89,
    r: 19
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 238.4,
    cy: 151.89,
    r: 19
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.74,87.56c-4.31,18.7-13.7,34.58-30.86,46.15-18.52,12.82-38.07,19-59.4,23.25.54-13.11-.9-31.55,5.86-43.24a79.48,79.48,0,0,1,32.31-30.36c14.81-7.65,37.72-15.15,54.36-9.85A113.76,113.76,0,0,1,209.74,87.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211.48,143.55c-.08.34,7.92,32.34,7.92,32.34H206.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M222.94,133.34a31.08,31.08,0,0,1,22.85-2.16"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.83,137a36.75,36.75,0,0,1,31.23-1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 204.27,
    y1: 154.89,
    x2: 219.4,
    y2: 153.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.49,294.57a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38A46.35,46.35,0,0,0,153,250.46,44.69,44.69,0,0,0,157.63,236a28.66,28.66,0,0,0,2.22,1.94,95.14,95.14,0,0,0,19.82,11.26,99,99,0,0,0,10.46,3.69,93.52,93.52,0,0,0,33,3.49c1.54-.12,3.09-.27,4.63-.38l.15,5.08v.33l12.1,4.92Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M185.49,187.18a1.87,1.87,0,0,1,2.69-.5c2.07,1.46,5.87,4.56,11.27,5.63,7.36,1.47,13.75-1.48,15.27.42.86,1.07-.19,2.38-2.2,4.05a19.72,19.72,0,0,1-14.85,3.69c-7.09-1.33-12.4-9.53-12.4-12.44A1.68,1.68,0,0,1,185.49,187.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSvgrepoCom2);
export default __webpack_public_path__ + "static/media/avatar-svgrepo-com (2).187a7ed159a7c6fa784863bce7fe9737.svg";
export { ForwardRef as ReactComponent };